<template>
   <div>
        <PageHeader :linkto="'/Sales/Dashboard'" :linkttitle="'返回'" title="綁定客戶"></PageHeader>

        <b-container>

            <b-input-group
                    class="mb-3"
                    prepend="搜尋客戶"


            >
                <b-form-input
                        v-model="invitecode"
                        type="text"
                        maxlength="10"
                        required
                        placeholder="輸入手機號碼"
                        @change="checkvalue('invitecode')"
                ></b-form-input>
                <b-input-group-append>
                    <b-button  text="Button" variant="success"  @click="searchClient">搜尋</b-button>
                </b-input-group-append>
            </b-input-group>

            <b-card v-if="searchview" header="搜索結果" class="text-center shadow-lg m-2">

                <div v-if="searchempty">
                    {{searchresult}}
                </div>

                    <b-row v-else align-v="center">
                        <b-col>
                           {{searchresult.first_name + searchresult.last_name }}
                        </b-col>
                        <b-col>
                            {{searchresult.username  }}
                        </b-col>
                        <b-col cols="12" class="mt-3" >
                            <b-button v-if="profiledata.uuid == searchresult.salesbind" text="Button" variant="success" class="shadow" block  disabled ><b-icon-plus-circle></b-icon-plus-circle> {{ searchresult.first_name+searchresult.last_name }} 已完成綁定</b-button>
                            <b-button v-else-if="searchresult.salesbind !== profiledata.uuid && searchresult.salesbind !== null " text="Button" variant="success" class="shadow" block  disabled ><b-icon-plus-circle></b-icon-plus-circle> 無法綁定</b-button>
                            <b-button v-else text="Button" variant="success" class="shadow" block  @click="inviteClient"><b-icon-plus-circle></b-icon-plus-circle> 點擊綁定客戶</b-button>
                        </b-col>
                    </b-row>


            </b-card>
            <hr>

            <b-card no-body class="overflow-hidden p-2 mb-2">
                <h5 class="m-2">已綁定的客戶</h5>

                <!--{{ items }}-->
            <b-table  id="client" stacked="sm" striped hover :items="items" :fields="fields" :busy="isBusy">
                <template v-slot:table-busy>
                    <div class="text-center text-success my-2">
                        <b-spinner class="align-middle"></b-spinner>
                    </div>
                </template>
                <template v-slot:cell(numid)="data">
                    {{ (data.index+1)+((currentPage-1)*limit) }}
                </template>
                <template v-slot:cell(member)="row">
                    <p v-if="row.item.vip_lv==0">註冊會員</p>
                    <p v-if="row.item.vip_lv==1">白金會員</p>
                    <h5 v-if="row.item.vip_lv==2"><b-badge variant="success">黃金會員</b-badge></h5>
                </template>
                <template v-slot:cell(name)="row">
                    {{ row.item.first_name + row.item.last_name }}
                </template>

                <template v-slot:cell(salesbind_date)="row">
                    {{ gofnTime(row.item.salesbind_date) }}
                </template>

            </b-table>
                <b-pagination v-if="items.length > 0"
                        v-model="currentPage"
                        :total-rows="itemstotal"
                        :per-page="perPage"
                              pills
                              align="center"
                              @change="changePage"
                ></b-pagination>
            </b-card>
        </b-container>
    </div>
</template>

<script>

import PageHeader from '@/components/PageHeader.vue'
import {toastsModel, alertModel,fnTime } from '@/service/commuse'

import {mapState} from 'vuex'

export default {
  name: 'MyClient',
  components: {PageHeader},
  data () {
    return {
      selected: null,
      invitecode:'',
      invitecode_check:false,
      searchview:false,
      searchempty:false,
      searchresult:'',

      options: [{ value: null, text: '請選擇'}],

      fields: [
        {
          key: 'numid',
          label: '序號',
          sortable: true
        },
        {
          key: 'name',
          label: '姓名',
          sortable: false
        },
        {
          key: 'member',
          label: '會員',
          sortable: false
        },
        {
          key: 'username',
          label: '手機',
          sortable: true,
        },
        {
          key: 'salesbind_date',
          label: '綁定日期',
          sortable: true,
        },
      ],
      items: [],
      itemstotal:0,
      itemcheck:false,
      isBusy:false,
      limit: 10,
      pages:0,
      perPage:10,
      currentPage:1
    }
  },
  computed: {
    ...mapState(['profiledata']),
  },
  created(){
    this.$store.dispatch('actionGetCheckSales', {}).catch((res) =>{  this.$router.push('/home')})
  },
  mounted(){
    this.loadData();
  },
  methods: {

    loadData(){
      this.isBusy = true
      this.$store.dispatch('actionMyInviteClientNew', {
        limit:this.limit,
        offset:0,
      }).then((res) => {

        this.items = res.data.listdata
        this.itemstotal =  res.data.total
        this.isBusy = false
        console.log(res)

      })
    },
    changePage: function (num) {
      this.isBusy = true
      this.pages = num
      this.$store.dispatch('actionMyInviteClientNew', {
        limit:this.limit,
        'offset': (num - 1) * this.limit,
      }).then((res) => {

        this.items = res.data.listdata
        this.itemstotal =  res.data.total
        this.isBusy = false

      })
    },
    checkvalue (way) {
      switch (way) {
        case 'invitecode':
          if (this.invitecode.length == 0) {
            this.invitecode_check = false
          } else {
            this.invitecode_check = true
          }
          break
        case 'allitem':

          let countTotal = 0;
          this.itemcheck = false
          for (let i = 0; i <  this.items.length; i++) {
            if( this.items[i]['plan'] === ''){
              countTotal =countTotal+1
              this.itemcheck = false
            }
          }
          if(countTotal==0){
            this.itemcheck = true
          }
          break
        case 'item':
          for (let i = 0; i <  this.items.length; i++) {
            this.itemcheck = true
            if( this.items[i]['plan'] == ''){
              this.itemcheck = false
            }

          }


          break
      }

    },
    searchClient(){
      this.checkvalue('invitecode')

      if( this.invitecode_check == true
      ){

        this.$store.dispatch('actionSearchClient', {
          phone:this.invitecode

        }).then((res) => {

          this.searchview = true
          this.searchresult = res.data
          this.searchempty = false

        }).catch((res) => {
          this.searchempty = true
          this.searchview = true
          this.searchresult = res.message
          this.invitecode = ''
        })
      }

    },
    inviteClient(){
      this.$store.dispatch('actionInviteClient', {
        phone:this.invitecode,
        type:'C'
      }).then((res) => {
        this.searchempty = false
        this.searchview = false
        this.searchresult = ''
        this.invitecode = ''
        alertModel(this,"系統訊息",res.message)
        this.loadData();
      }).catch((res) => {
        alertModel(this,"系統訊息",res.message)
      })
    },
    gofnTime(time){
      return fnTime(time);
    }



  }
}
</script>
